import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ReactGA from "react-ga";

import "react-toastify/dist/ReactToastify.css";
import Login from "../Login";
import Home from "../Home";
import ResetPassword from "../ResetPassword";
import ScheduleQueryListing from "../ScheduleQueries/pages/ScheduleQueryListing";
import ScheduleQueryDetail from "../ScheduleQueries/pages/ScheduleQueryDetail";
import ScheduleQueryEdit from "../ScheduleQueries/pages/ScheduleQueryEdit";

import TransformationListing from "../Transformations/pages/TransformationListing";
import TransformationDetail from "../Transformations/pages/TransformationDetail";
import TransformationEdit from "../Transformations/pages/TransformationEdit";
import TransformationRunLog from "../Transformations/pages/TransformationRunLog";

import api from "../../api";
import DatasourceListing from "pages/Datasources/pages/DatasourceListing";
import DatasourceDetail from "pages/Datasources/pages/DatasourceDetail";
import DatasourceEdit from "pages/Datasources/pages/DatasourceEdit";
import UserEdit from "pages/Users/pages/UserEdit";

import DictionarySearching from "pages/Search/pages/DictionarySearching";
import DatasetDetail from "pages/DataDictionary/DatasetDetail";
import TableDetail from "pages/DataDictionary/TableDetail";
import DataDictionaryChangelog from "pages/DataDictionary/DictionaryChangelog";

import DataPipeline from "pages/DataPipeline";
import DataPipelineEdit from "pages/DataPipeline/DataPipelineEdit";
import DataPipelineLog from "pages/DataPipeline/DataPipelineLog";
import DataPipelineTaskLog from "pages/DataPipeline/PipelineTaskLog";

import Monitoring from "pages/Monitoring";
import Dashboard from "pages/Monitoring/Dashboard";
import DashboardEdit from "pages/Monitoring/Dashboard/SetupDashboard";
import Alerting from "pages/Monitoring/Alerting";
import AlertEdit from "pages/Monitoring/Alerting/AlertEdit";

import { Wrapper } from '../../components/AnalyticsTracking';
// The Main component renders one of the three provided
// Routes (provided that one matches). Both the /roster
// and /schedule routes will match any pathname that starts
// with /roster or /schedule. The / route will only match
// when the pathname is exactly the string "/"
//https://medium.com/@pshrmn/a-simple-react-router-v4-tutorial-7f23ff27adf

// For loggin handling, use component={CheckForLogIn}
// This ensure that all the pages required log in will be run AFTER our login logic
// https://medium.com/the-many/adding-login-and-authentication-sections-to-your-react-or-react-native-app-7767fd251bd1

interface PrivateRouteProps {
  component: any;
}

function PrivateRoute({ component: Component, ...rest }: PrivateRouteProps) {
  const [authed, setAuthed] = useState(true);
  useEffect(() => {
    const token = api.getAccessToken();
    if (!token) {
      setAuthed(false);
    }
  }, []);
  return (
    <Route
      {...rest}
      render={(props) =>
        authed ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/login",
            }}
          />
        )
      }
    />
  );
}
export default function Main() {

  ReactGA.initialize('UA-213434834-1');

  return (
    <main>
      <Switch>
        <Wrapper>
        <Route exact path="/login" component={Login} />
        <PrivateRoute {...{
          component: Home,
          exact: true,
          path: "/"
          }}
        />
        {/* User */}
        <PrivateRoute
          {...{
            component: ResetPassword,
            exact: true,
            path: "/reset_password",
          }}
        />
        {/* Schedule queries */}
        <PrivateRoute
          {...{
            component: ScheduleQueryListing,
            exact: true,
            path: "/schedule_queries",
          }}
        />
        <PrivateRoute
          {...{
            component: ScheduleQueryDetail,
            exact: true,
            path: "/schedule_query/:schedule_query_id",
          }}
        />
        <PrivateRoute
          {...{
            component: ScheduleQueryEdit,
            exact: true,
            path: "/schedule_query/:schedule_query_id/edit",
          }}
        />
        <PrivateRoute
          {...{
            component: ScheduleQueryEdit,
            exact: true,
            path: "/create_schedule_query",
          }}
        />
        {/* Transformation */}
        <PrivateRoute
          {...{
            component: TransformationListing,
            exact: true,
            path: "/transformations",
          }}
        />
        <PrivateRoute
          {...{
            component: TransformationDetail,
            exact: true,
            path: "/transformation/:transformation_id",
          }}
        />
        <PrivateRoute
          {...{
            component: TransformationEdit,
            exact: true,
            path: "/transformation/:transformation_id/edit",
          }}
        />
        <PrivateRoute
          {...{
            component: TransformationRunLog,
            exact: true,
            path: "/transformation/:transformation_id/run_log",
          }}
        />
        <PrivateRoute
          {...{
            component: TransformationEdit,
            exact: true,
            path: "/create_transformation",
          }}
        />
        <PrivateRoute
          {...{
            component: DatasourceListing,
            exact: true,
            path: "/datasources",
          }}
        />
        <PrivateRoute
          {...{
            component: DatasourceDetail,
            exact: true,
            path: "/datasource/:datasource_id",
          }}
        />
        <PrivateRoute
          {...{
            component: DatasourceEdit,
            exact: true,
            path: "/create_datasource",
          }}
        />
        <PrivateRoute
          {...{
            component: DatasourceEdit,
            exact: true,
            path: "/datasource/:datasource_id/edit",
          }}
        />
        <PrivateRoute
          {...{
            component: UserEdit,
            exact: true,
            path: "/create_user",
          }}
        />
        {/* Data Dictionary */}
        <PrivateRoute
          {...{
            component: DictionarySearching,
            exact: true,
            path: "/dictionary",
          }}
        />
        <PrivateRoute
          {...{
            component: DatasetDetail,
            exact: true,
            path: "/dataset/:dataset_id",
          }}
        />
        <PrivateRoute
          {...{
            component: TableDetail,
            exact: true,
            path: "/table/:table_id",
          }}
        />
        {/* Data pipeline */}
        <PrivateRoute
          {...{
            component: DataPipeline,
            exact: true,
            path: "/data_pipeline",
          }}
        />
        <PrivateRoute
          {...{
            component: DataPipelineEdit,
            exact: true,
            path: "/data_pipeline/:action/:data_pipeline_id",
          }}
        />
        <PrivateRoute
          {...{
            component: DataPipelineLog,
            exact: true,
            path: "/data_pipeline_log/:data_pipeline_id",
          }}
        />
        <PrivateRoute
          {...{
            component: DataPipelineTaskLog,
            exact: true,
            path: "/data_pipeline_log/:data_pipeline_id/task/:data_pipeline_task_id",
          }}
        />
        <PrivateRoute
          {...{
            component: DataDictionaryChangelog,
            exact: true,
            path: "/dictionary/changelog/:metadata_type/:reference_id"
          }}
        />
        {/* Monitoring */}
        <PrivateRoute
          {...{
            component: Monitoring,
            exact: true,
            path: "/monitoring"
          }}
        />
        <PrivateRoute
          {...{
            component: Dashboard,
            exact: true,
            path: "/monitoring/dashboard"
          }}
        />
        <PrivateRoute
          {...{
            component: DashboardEdit,
            exact: true,
            path: "/monitoring/dashboard/setup/:action/:dashboard_id"
          }}
        />
        <PrivateRoute
          {...{
            component: Alerting,
            exact: true,
            path: "/monitoring/alerting"
          }}
        />
        <PrivateRoute
          {...{
            component: AlertEdit,
            exact: true,
            path: "/monitoring/alerting/:action/:alert_id"
          }}
        />
        </Wrapper>
      </Switch>
      <ToastContainer position="top-right" autoClose={1000} pauseOnHover />
    </main>
  );
}
